let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4lpFw")).then(() => parcelRequire('58KwD'));